export { default as Zoomable } from './zoomable'

export const ImageFolders = {
  vehicle: 'vehicle',
  profile: 'profileImages',
  conversation: 'conversationFiles',
  benefitsProgramLogo: 'benefitsProgramLogoImages',
}

export const ImageTypes = {
  requiresResize: 0,
  native: 1,
}

export const generateImgSrc = ({
  src,
  type = ImageTypes.requiresResize,
  height,
  width,
  folder = ImageFolders.vehicle,
  quality = '95',
  fullRes = false,
}) => {
  if (type === ImageTypes.native) return src

  // if it's a fully-qualified URL, it's not hosted on our CDN so we cannot resize it
  const isValidHttpUrl = (src) => {
    let urlObj
    try {
      urlObj = new URL(src)
    } catch (_) {
      return false
    }
    return urlObj?.protocol === 'http:' || urlObj?.protocol === 'https:'
  }
  if (isValidHttpUrl(src)) return src

  let url = process.env.NEXT_PUBLIC_IMAGE_CDN

  if (fullRes) {
    url += `/filters:quality(100)/filters:strip_exif()/fit-in/1920x1080/${folder}/${src}`
  } else {
    url += `/filters:strip_exif()/filters:quality(${quality})/fit-in/${width}x${height}/${folder}/${src}`
  }

  return url
}

export default function Image({ src, type, height, width, folder, quality, fullRes, ...imgProps }) {
  return (
    //eslint-disable-next-line jsx-a11y/alt-text
    <img
      src={generateImgSrc({ src, type, height, width, folder, quality, fullRes })}
      width={width}
      height={height}
      {...imgProps}
    />
  )
}
